(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const bindCustomsConsent = (root = document) => {
      root.querySelectorAll('[data-customs-consent]').forEach((container) => {
        if (container.hasAttribute('data-customs-consent-bound')) {
          return;
        }

        const checkbox = container.querySelector('[data-customs-consent-checkbox]');
        const form = container.closest('form');
        const checkout = form?.querySelector('[data-customs-consent-checkout]');

        if (!checkbox || !form || !checkout) {
          return;
        }

        const syncCheckout = () => {
          checkout.disabled = !checkbox.checked;
          checkout.setAttribute('aria-disabled', checkbox.checked ? 'false' : 'true');
        };

        container.setAttribute('data-customs-consent-bound', 'true');
        checkbox.addEventListener('change', syncCheckout);
        form.addEventListener('submit', (event) => {
          if (!checkbox.checked) {
            event.preventDefault();
            syncCheckout();
            checkbox.focus();
          }
        });
        syncCheckout();
      });
    };

    bindCustomsConsent();
    document.documentElement.addEventListener('cart:rerendered', () => bindCustomsConsent());
  })();

  } catch(e) { console.error(e); }
})();
})();
